import { useAuth0 } from '@auth0/auth0-react';
import { FontAwesomeIcon, IconProp } from '@grc/ui-package';

const LogoutButton = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    localStorage.clear();
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  return (
    <button className="btn btn-danger btn-block" onClick={handleLogout}>
      <FontAwesomeIcon
        icon={'fa-regular fa-arrow-right-from-bracket' as IconProp}
        className="mr-2"
      />
      Log Out
    </button>
  );
};

export default LogoutButton;
